import { defineMessages } from 'react-intl';

/**
 * The empty state's own chrome. Starter labels come from the server
 * catalogue in English on purpose — see src/chat/nudges/messages.ts.
 */
export default defineMessages({
  greeting: {
    id: 'comp.ChatEmptyState.greeting',
    defaultMessage: 'What can I help with?',
  },
  contextLibraryEmpty: {
    id: 'comp.ChatEmptyState.contextLibraryEmpty',
    defaultMessage: 'Your library is empty. Let’s get some files in.',
  },
  contextLibrary: {
    id: 'comp.ChatEmptyState.contextLibrary',
    defaultMessage: 'Your library has {count, plural, one {# asset} other {# assets}}.',
  },
  contextAsset: {
    id: 'comp.ChatEmptyState.contextAsset',
    defaultMessage: 'Looking at {name}.',
  },
  contextAssetUnnamed: {
    id: 'comp.ChatEmptyState.contextAssetUnnamed',
    defaultMessage: 'Looking at this asset.',
  },
  contextCollections: {
    id: 'comp.ChatEmptyState.contextCollections',
    defaultMessage: 'Working with your collections.',
  },
  contextCollection: {
    id: 'comp.ChatEmptyState.contextCollection',
    defaultMessage: 'Looking at this collection.',
  },
  contextShares: {
    id: 'comp.ChatEmptyState.contextShares',
    defaultMessage: 'Working with your shares.',
  },
  contextShare: {
    id: 'comp.ChatEmptyState.contextShare',
    defaultMessage: 'Looking at this share.',
  },
  contextSelectionImage: {
    id: 'comp.ChatEmptyState.contextSelectionImage',
    defaultMessage: 'Working with {count, plural, one {# selected image} other {# selected images}}.',
  },
  contextSelectionVideo: {
    id: 'comp.ChatEmptyState.contextSelectionVideo',
    defaultMessage: 'Working with {count, plural, one {# selected video} other {# selected videos}}.',
  },
  contextSelection: {
    id: 'comp.ChatEmptyState.contextSelection',
    defaultMessage: 'Working with {count, plural, one {# selected asset} other {# selected assets}}.',
  },
  startersLabel: {
    id: 'comp.ChatEmptyState.startersLabel',
    defaultMessage: 'Suggestions',
  },
  browseAll: {
    id: 'comp.ChatEmptyState.browseAll',
    defaultMessage: 'Browse all',
  },
  back: {
    id: 'comp.ChatEmptyState.back',
    defaultMessage: 'Back',
  },
  browseTitle: {
    id: 'comp.ChatEmptyState.browseTitle',
    defaultMessage: 'Browse all',
  },
  searchPlaceholder: {
    id: 'comp.ChatEmptyState.searchPlaceholder',
    defaultMessage: 'Search',
  },
  searchLabel: {
    id: 'comp.ChatEmptyState.searchLabel',
    defaultMessage: 'Search everything the agent can do',
  },
  noMatches: {
    id: 'comp.ChatEmptyState.noMatches',
    defaultMessage: 'Nothing matches “{query}”. Try other words, or type your request below.',
  },
});
